import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    z-index: 1000000;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #1B1B1B;
    background: #1B1B1B;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const Background2 = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
}
`;
